import { FieldErrors, useFormContext } from "react-hook-form";
import { ErrorMessage, PasswordInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpClientFormData, SignUpDriverFormData, SignUpInviteFormData, SignUpOperatorFormData } from "../types";

export const ConfirmPasswordField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpDriverFormData | SignUpOperatorFormData | SignUpClientFormData | SignUpInviteFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Confirm Password</Typography>
      <PasswordInput
        className="w-full"
        hasError={!!errors.password?.confirmPassword}
        placeholder="Enter Password"
        autoComplete="new-password"
        maxLength={65}
        {...register("password.confirmPassword")}
      />
      {errors.password?.confirmPassword && <ErrorMessage errors={errors.password as FieldErrors} name="confirmPassword" />}
    </div>
  );
};
